class ScAnnouncement extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.slides = [...this.querySelectorAll('.sc-announcement__slides > p')];
    this.index = 0;
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.querySelector('[data-previous]')?.addEventListener('click', () => { this.advance(-1); this.start(); }, options);
    this.querySelector('[data-next]')?.addEventListener('click', () => { this.advance(1); this.start(); }, options);
    this.querySelector('[data-pause-button]')?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.start(); }, options);
    this.addEventListener('mouseenter', () => clearInterval(this.timer), options);
    this.addEventListener('mouseleave', () => this.start(), options);
    this.addEventListener('focusin', () => clearInterval(this.timer), options);
    this.addEventListener('focusout', () => this.start(), options);
    this.updatePause(); this.start();
  }
  advance(direction) {
    if (!this.slides.length) return;
    this.slides[this.index].hidden = true;
    this.index = (this.index + direction + this.slides.length) % this.slides.length;
    this.slides[this.index].hidden = false;
  }
  updatePause() {
    const button = this.querySelector('[data-pause-button]');
    if (!button) return;
    button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
    button.setAttribute('aria-pressed', String(this.paused));
    button.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
  }
  start() {
    clearInterval(this.timer);
    if (!this.paused && this.slides.length > 1 && !this.contains(document.activeElement)) this.timer = setInterval(() => this.advance(1), 4500);
  }
  disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); }
}
if (!customElements.get('sc-announcement')) customElements.define('sc-announcement', ScAnnouncement);

// Shopify returns customer forms to their fragment. On desktop, Horizon scrolls
// inside page-wrapper; the browser can also move the outer document to the hash.
// Keep the native submission and position only the appropriate scroll container.
function positionNewsletterResponse() {
  const form = document.getElementById(location.hash.slice(1));
  if (!form?.matches('.sc-newsletter form')) return;
  const feedback = form.querySelector('[role="status"], [role="alert"]');
  if (!feedback) return;

  const position = () => requestAnimationFrame(() => {
    const wrapper = form.closest('.page-wrapper');
    const header = document.getElementById('header-component');
    const offset = (header?.getBoundingClientRect().height || 80) + 100;
    if (wrapper && matchMedia('(min-width: 990px)').matches && getComputedStyle(wrapper).overflowY === 'auto') {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      wrapper.scrollTo({
        top: wrapper.scrollTop + form.getBoundingClientRect().top - wrapper.getBoundingClientRect().top - offset,
        behavior: 'instant',
      });
    } else {
      window.scrollTo({
        top: window.scrollY + form.getBoundingClientRect().top - offset,
        behavior: 'instant',
      });
    }
    feedback.setAttribute('tabindex', '-1');
    feedback.focus({ preventScroll: true });
  });
  position();

  // Recommendations can arrive after load and move the footer. Follow those
  // layout changes only until the visitor starts interacting with the page.
  const controller = new AbortController();
  const observer = new ResizeObserver(position);
  const main = document.getElementById('MainContent');
  if (main) observer.observe(main);
  const stop = () => { observer.disconnect(); controller.abort(); };
  for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown', 'pagehide']) {
    window.addEventListener(event, stop, { once: true, passive: true, signal: controller.signal });
  }
}
window.addEventListener('pageshow', positionNewsletterResponse);
if (document.readyState === 'complete') positionNewsletterResponse();

